import { render } from "./ParticipanteMiNombreEs.vue?vue&type=template&id=28fcf8e2&scoped=true"
import script from "./ParticipanteMiNombreEs.vue?vue&type=script&lang=js"
export * from "./ParticipanteMiNombreEs.vue?vue&type=script&lang=js"

import "./ParticipanteMiNombreEs.vue?vue&type=style&index=0&id=28fcf8e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fcf8e2"]])

export default __exports__